import '@progress/kendo-theme-classic/dist/all.css';
import './styles/App.scss';
import { Routes, Route, Navigate } from "react-router-dom";
import routes from "./routes";

function App() {

  // function handleResize(){
  //   window.parent.postMessage({
  //       'height': document.body.scrollHeight
  //   }, '*'); // Use a specific domain instead of '*' for better security  
  // }

  // window.addEventListener('resize', handleResize);

  // setTimeout(() => {
  //   handleResize();
  // }, 500);


  // Helper to flatten nested arrays
  const flatten = (arr: any[]): any[] => arr.reduce(
    (flat, toFlatten) => flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten),
    []
  );

  const getRoutes = (allRoutes: any, parentKey = '') =>
    allRoutes.map((route: any, idx: number) => {
      if (route.collapse) {
        return getRoutes(route.collapse, parentKey + (route.key || idx) + '-');
      }
      if (route.route) {
        // Compose a unique key using parentKey and route.key or idx
        const uniqueKey = parentKey + (route.key || idx);
        return (
          <Route
            path={route.route}
            element={route.component}
            key={uniqueKey}
          />
        );
      }
      return null;
    });

  return (
    <Routes>
      {flatten(getRoutes(routes))}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
